module.exports = "/img/20.baaaff.webp";